import { Link } from 'react-router-dom';

export default function UseCasesSection() {
  const useCases = [
    { icon: 'ri-shopping-cart-line', title: 'E-commerce tracking', desc: 'Suivez vos ventes et stocks en temps réel', link: '/article/hipobuy-spreadsheet-ecommerce' },
    { icon: 'ri-bar-chart-line', title: 'Data analysis', desc: 'Analysez vos données avec des tableaux croisés dynamiques', link: '/article/guide-complet-hipobuy-spreadsheet' },
    { icon: 'ri-megaphone-line', title: 'Marketing automation', desc: 'Automatisez vos campagnes et rapports marketing', link: '/article/hipobuy-spreadsheet-automatisation' },
    { icon: 'ri-rocket-line', title: 'Startup dashboards', desc: 'Créez des tableaux de bord pour votre startup', link: '/article/hipobuy-spreadsheet-debutant' },
    { icon: 'ri-bank-line', title: 'Financial tracking', desc: 'Gérez vos finances avec précision et clarté', link: '/article/hipobuy-spreadsheet-tarifs' },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-3">
              / Cas d&apos;usage /
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-900">
              Comment utiliser Hipobuy Spreadsheet
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              Des solutions adaptées à chaque besoin professionnel
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {useCases.map((item) => (
              <Link
                key={item.title}
                to={item.link}
                className="bg-background-50 rounded-xl p-5 border border-background-200/60 hover:border-primary-200 transition-all duration-300 text-center group cursor-pointer"
              >
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 group-hover:bg-accent-200 transition-colors">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <h4 className="font-heading font-semibold text-foreground-900 text-sm mb-1">{item.title}</h4>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </Link>
            ))}
          </div>

          <div className="text-center mt-10">
            <Link
              to="/article/guide-complet-hipobuy-spreadsheet"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
            >
              Voir tous les cas d&apos;utilisation
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}